import { styled } from '@mui/material'
import { useAtom } from 'jotai'
import { memo } from 'react'
import { PerpInfoTabTypes, perpInfoTabAtom } from './atoms'
import clsx from 'clsx'

const Wrap = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
`
const Tab = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: rgba(149, 164, 173, 1);
  padding: 0 12px;
  border-radius: 12px;
  cursor: pointer;

  &.active {
    color: rgba(160, 238, 9, 1);
    background-color: rgba(160, 238, 9, 0.1);
    cursor: default;
  }
`

export const PerpInfoTabs = memo(() => {
  const [tab, setTab] = useAtom(perpInfoTabAtom)
  return (
    <Wrap>
      <Tab
        className={clsx({ active: tab === PerpInfoTabTypes.ContractInfo })}
        onClick={() => setTab(PerpInfoTabTypes.ContractInfo)}
      >
        Contract info
      </Tab>
      <Tab
        className={clsx({ active: tab === PerpInfoTabTypes.FundingRate })}
        onClick={() => setTab(PerpInfoTabTypes.FundingRate)}
      >
        Funding Rate
      </Tab>
      <Tab
        className={clsx({ active: tab === PerpInfoTabTypes.InsuranceFund })}
        onClick={() => setTab(PerpInfoTabTypes.InsuranceFund)}
      >
        Insurance Fund
      </Tab>
    </Wrap>
  )
})
